import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = () => ({
  room: null,
  localStream: null,
  peerId: '',
  shareRoom: null,
  showApps: false,
  showAlert: false,
  showTextChat: false,
  constraints: {
    audio: {
      deviceId: ''
    },
    video: {
      deviceId: ''
    }
  },
  textChat: [],
  layout: {
    cover: true,
    type: 'tile',
    mainStreamPeerId: ''
  },
  stealth: false,
  users: {},
  iconImg: '',
  limitMembers: 0
})

const getters = {
  layoutCover (state) {
    return state.layout.cover ? { objectFit: 'cover' } : ''
  },
  layoutSubFlag: (state) => (peerId) => {
    // レイアウトがサイドバーかポップアップで、メイン表示でないpeerIdか判定
    return ['sidebar', 'popup'].includes(state.layout.type) && (peerId !== state.layout.mainStreamPeerId)
  },
  localUser (state) {
    return state.users[state.peerId]
  },
  joinMembers (state) {
    // 参加中のユーザー数（ステルスのユーザーは除外）
    return Object.keys(state.users).filter((peerId) => !state.users[peerId].shareFlag).length
  }
}

const mutations = {
  updateRoom (state, room) {
    state.room = room
  },
  updateShareRoom (state, room) {
    state.shareRoom = room
  },
  updateShowApps (state, flag) {
    state.showApps = flag
  },
  updatePeerId (state, peerId) {
    state.peerId = peerId
    state.layout.mainStreamPeerId = peerId
  },
  updateShowAlert (state, flag) {
    state.showAlert = flag
  },
  updateShowTextChat (state, flag) {
    state.showTextChat = flag
  },
  updateConstraints (state, constraints) {
    state.constraints = constraints
  },
  updateLocalStream (state, stream) {
    state.localStream = stream
  },
  updateTextChat (state, payload) {
    state.textChat.push(payload)
  },
  updateLayout (state, layout) {
    state.layout = {
      ...state.layout,
      ...layout
    }
  },
  updateStealth (state, flag) {
    state.stealth = flag
  },
  updateUsers (state, payload) {
    state.users[payload.peerId] = {
      ...state.users[payload.peerId],
      ...payload.data
    }

    // computedが動かすため
    state.users = { ...state.users }
  },
  removeUsers (state, peerId) {
    delete state.users[peerId]

    // computedが動かすため
    state.users = { ...state.users }
  },
  updateIconImg (state, img) {
    state.iconImg = img
  },
  updatelimitMembers (state, length) {
    state.limitMembers = length
  }
}

const actions = {
  updateRoom (context, data) {
    context.commit('updateRoom', data.room)
  },
  updateShareRoom (context, data) {
    context.commit('updateShareRoom', data.room)
  },
  updateShowApps (context, data) {
    context.commit('updateShowApps', data.flag)
  },
  updatePeerId (context, data) {
    context.commit('updatePeerId', data.peerId)
  },
  updateShowAlert (context, data) {
    context.commit('updateShowAlert', data.flag)
  },
  updateShowTextChat (context, data) {
    context.commit('updateShowTextChat', data.flag)
  },
  updateConstraints (context, data) {
    context.commit('updateConstraints', data.constraints)
  },
  updateLocalStream (context, data) {
    context.commit('updateLocalStream', data.stream)
  },
  updateTextChat (context, data) {
    context.commit('updateTextChat', data.payload)
  },
  updateLayout (context, data) {
    context.commit('updateLayout', data.layout)
  },
  updateStealth (context, data) {
    context.commit('updateStealth', data.flag)
  },
  updateUsers (context, data) {
    context.commit('updateUsers', data.payload)
  },
  removeUsers (context, data) {
    context.commit('removeUsers', data.peerId)
  },
  updateIconImg (context, data) {
    context.commit('updateIconImg', data.img)
  },
  updatelimitMembers (context, data) {
    context.commit('updatelimitMembers', data.length)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
